import { gql } from "@apollo/client";

const ORDER_SUMMARY_FIELDS = `
  id
  pickup_type
  customer_id
  order_no
  bag_no
  location
  status
  note
  createdAt
  received_date
  delivery_date
  amount
  amount_paid
  amount_due
  payment_status
  approval_status
  pickup_slot_date
  pickup_slot { id label start_time end_time }
  delivery_slot_date
  delivery_slot { id label start_time end_time }
`;

const ORDER_DETAIL_FIELDS = `
  ${ORDER_SUMMARY_FIELDS}
  subtotal
  discount_amount
  promo_code
  payment_link
  approval_deadline
  dispute_note
  has_condition_notes
  items {
    id
    name
    service
    quantity
    unit_price
    line_total
    image
    condition_note
    condition_photo
  }
  payments { id amount method createdAt }
  status_history { id from_status to_status createdAt }
`;

export const ORDER_QUERY = gql`
  query Order($id: ID!) {
    order(id: $id) {
      ${ORDER_DETAIL_FIELDS}
    }
  }
`;

export const CUSTOMER_ORDERS_QUERY = gql`
  query CustomerOrders($status: String!) {
    customerOrders(status: $status) {
      ${ORDER_SUMMARY_FIELDS}
    }
  }
`;

export const CREATE_ORDER_MUTATION = gql`
  mutation CreateOrder(
    $pickupType: PickType!
    $bagNo: String!
    $location: String!
    $note: String
    $pickupSlotId: ID
    $pickupSlotDate: String
  ) {
    createOrder(
      pickup_type: $pickupType
      bag_no: $bagNo
      location: $location
      note: $note
      pickup_slot_id: $pickupSlotId
      pickup_slot_date: $pickupSlotDate
    ) {
      ${ORDER_SUMMARY_FIELDS}
    }
  }
`;

export const APPROVE_ORDER_MUTATION = gql`
  mutation ApproveOrder($id: ID!) {
    approveOrder(order_id: $id) {
      ${ORDER_DETAIL_FIELDS}
    }
  }
`;

export const CONFIRM_ORDER_PAYMENT_MUTATION = gql`
  mutation ConfirmOrderPayment($id: ID!, $paymentId: String) {
    confirmOrderPayment(order_id: $id, payment_id: $paymentId) {
      ${ORDER_DETAIL_FIELDS}
    }
  }
`;

export const REPORT_ORDER_ISSUE_MUTATION = gql`
  mutation ReportOrderIssue($id: ID!, $message: String!) {
    reportOrderIssue(order_id: $id, message: $message) {
      ${ORDER_DETAIL_FIELDS}
    }
  }
`;

export const SET_DELIVERY_SLOT_MUTATION = gql`
  mutation SetDeliverySlot($id: ID!, $slotId: ID!, $date: String!) {
    setDeliverySlot(order_id: $id, slot_id: $slotId, date: $date) {
      ${ORDER_DETAIL_FIELDS}
    }
  }
`;

export const AVAILABLE_TIME_SLOTS_QUERY = gql`
  query AvailableTimeSlots($type: SlotKind!, $date: String!) {
    availableTimeSlots(type: $type, date: $date) {
      slot { id label start_time end_time }
      date
      remaining
      available
    }
  }
`;
